export default __webpack_public_path__ + "static/media/rad-bear-studios-bot-sm.3dcc6879.jpg";